<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9997 9.16683H3.99967C3.59967 9.16683 3.33301 8.90016 3.33301 8.50016C3.33301 8.10016 3.59967 7.8335 3.99967 7.8335H11.9997C12.3997 7.8335 12.6663 8.10016 12.6663 8.50016C12.6663 8.90016 12.3997 9.16683 11.9997 9.16683Z"
      fill="#8C8C8C"
    />
    <path
      d="M9.99967 13.1668H5.99967C5.59967 13.1668 5.33301 12.9002 5.33301 12.5002C5.33301 12.1002 5.59967 11.8335 5.99967 11.8335H9.99967C10.3997 11.8335 10.6663 12.1002 10.6663 12.5002C10.6663 12.9002 10.3997 13.1668 9.99967 13.1668Z"
      fill="#8C8C8C"
    />
    <path
      d="M13.9997 5.16683H1.99967C1.59967 5.16683 1.33301 4.90016 1.33301 4.50016C1.33301 4.10016 1.59967 3.8335 1.99967 3.8335H13.9997C14.3997 3.8335 14.6663 4.10016 14.6663 4.50016C14.6663 4.90016 14.3997 5.16683 13.9997 5.16683Z"
      fill="#8C8C8C"
    />
  </svg>
</template>
